"use client";

import { c as _c } from "react/compiler-runtime";
import MovieHero from "./MovieHero";
import MovieHeader from "./MovieHeader";
import MovieMeta from "./MovieMeta";
import MovieCredits from "./MovieCredits";
import MovieActions from "./MovieActions";
import GenreTags from "../_shared/GenreTags";
import LikedPercent from "../_shared/LikedPercent";
import type { Movie, Person, Tag } from "@/types/movies";
import type { BackgroundImages } from "../_shared/contentMeta";
interface Props {
  movie: Movie;
  images: BackgroundImages;
  year: string;
  countries: Tag[];
  genres: Tag[];
  subtitles: string;
  persons: Person[];
  durationLabel: string;
  hasActiveSubscription: boolean;
  hasActiveTicket: boolean;
  onBuyClick: () => void;
}
export default function MovieHeroSection(t0) {
  const $ = _c(35);
  const {
    movie,
    images,
    year,
    countries,
    genres,
    subtitles,
    persons,
    durationLabel,
    hasActiveSubscription,
    hasActiveTicket,
    onBuyClick
  } = t0;
  const t1 = movie?.uuid;
  const t2 = movie?.title_fa || "";
  const t3 = movie?.title_en || "";
  const t4 = movie?.in_watchlist || false;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = <MovieHeader uuid={t1} title={t2} title_en={t3} isbook={t4} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = movie?.age_restriction?.name || "";
  const t7 = String(movie?.imdb_rate ?? "");
  let t8;
  if ($[5] !== countries || $[6] !== durationLabel || $[7] !== subtitles || $[8] !== t6 || $[9] !== t7 || $[10] !== year) {
    t8 = <div className="w-full hidden lg:block"><MovieMeta ageLimit={t6} seasons={durationLabel} year={year} rating={t7} countries={countries} subtitles={subtitles} /></div>;
    $[5] = countries;
    $[6] = durationLabel;
    $[7] = subtitles;
    $[8] = t6;
    $[9] = t7;
    $[10] = year;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== persons) {
    t9 = persons.length > 0 && <MovieCredits stars={persons} />;
    $[12] = persons;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== genres) {
    t10 = <GenreTags tags={genres} className="hidden lg:flex sm:mt-4 md:mt-6" />;
    $[14] = genres;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = movie?.trailers?.[0]?.uuid || "";
  const t12 = movie?.content_access || "";
  const t13 = movie?.uuid || "";
  const t14 = movie?.title_fa || movie?.title_en || "";
  const t15 = movie?.coming_soon;
  let t16;
  if ($[16] !== hasActiveSubscription || $[17] !== hasActiveTicket || $[18] !== images || $[19] !== onBuyClick || $[20] !== t11 || $[21] !== t12 || $[22] !== t13 || $[23] !== t14 || $[24] !== t15) {
    t16 = <div className="w-full hidden lg:block"><MovieActions traileruuid={t11} status={t12} poster={images} uuid={t13} title={t14} onBuyClick={onBuyClick} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} comingSoon={t15} /></div>;
    $[16] = hasActiveSubscription;
    $[17] = hasActiveTicket;
    $[18] = images;
    $[19] = onBuyClick;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t16 || $[28] !== t5 || $[29] !== t8 || $[30] !== t9) {
    t17 = <div className="absolute bottom-4 md:top-1/8 lg:top-1/8 xl:top-1/5 mx-auto container max-w-3xl px-4 sm:px-6 lg:px-12 pt-20 sm:pt-24">{t5}{t8}{t9}{t10}{t16}</div>;
    $[26] = t10;
    $[27] = t16;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== images || $[33] !== t17) {
    t18 = <MovieHero background={images}>{t17}</MovieHero>;
    $[32] = images;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
}